import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import React from 'react';

import Button from 'uikit/Button';
import Menu, { MenuItem } from 'uikit/Menu';

import styles from './Actions.module.scss';

const cx = classNames.bind(styles);

const Empty = ({
  className,
  handleChapterCreate,
  handleFileImport,
  handleQuestionCreate,
  handleQuestionImport,
  questionsInfo,
  t,
}) => (
  <div className={cx('container', className)}>
    <Menu
      placement="bottom-end"
      toggle={
        <Button data-testid="create-content-button" icon="plus" intent="white">
          {t('Course/Teacher/Editor/Actions/new')}
        </Button>
      }
      trigger="mouseenter focus click"
    >
      <div className={cx('question-create-item')}>
        <Menu
          placement="left"
          toggle={
            <MenuItem
              className={cx('question-create-chevron')}
              icon="chevron-left"
            />
          }
          trigger="mouseenter focus click"
        >
          {questionsInfo.informativeQuestions.map((info) => (
            <MenuItem
              icon={<img className={cx('icon')} alt="" src={info.icon} />}
              key={info.type}
              onClick={() => handleQuestionCreate(info.type)}
            >
              {t(info.name)}
            </MenuItem>
          ))}
          {questionsInfo.questions.map((info) => (
            <MenuItem
              icon={<img className={cx('icon')} alt="" src={info.icon} />}
              key={info.type}
              onClick={() => handleQuestionCreate(info.type)}
            >
              {t(info.name)}
            </MenuItem>
          ))}
        </Menu>
        <button
          className={cx('question-create-button')}
          data-testid="create-question-button"
          onClick={() => handleQuestionCreate(null)}
          type="button"
        >
          {t('Course/Teacher/Editor/Actions/create-question')}
        </button>
      </div>
      <MenuItem
        className={cx('question-create-item-small')}
        icon="plus"
        onClick={() => handleQuestionCreate(null)}
      >
        {t('Course/Teacher/Editor/Actions/create-question')}
      </MenuItem>
      <MenuItem icon="folder-plus" onClick={handleChapterCreate}>
        {t('Course/Teacher/Editor/Actions/create-chapter')}
      </MenuItem>
      <MenuItem icon="file-download" onClick={handleQuestionImport}>
        {t('Course/Teacher/Editor/Actions/import-question')}
      </MenuItem>
      <MenuItem icon="file-upload" onClick={handleFileImport}>
        {t('Course/Teacher/Editor/Actions/upload-file')}
      </MenuItem>
    </Menu>
  </div>
);

Empty.propTypes = {
  className: PropTypes.string,
  handleChapterCreate: PropTypes.func.isRequired,
  handleFileImport: PropTypes.func.isRequired,
  handleQuestionCreate: PropTypes.func.isRequired,
  handleQuestionImport: PropTypes.func.isRequired,
  questionsInfo: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
};

Empty.defaultProps = {
  className: undefined,
};

export default Empty;
